import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Button, Form, Dropdown } from "semantic-ui-react";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../services/auth";

const AtribuirSimulado = (props) => {
  const [simulados, setSimulados] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [search, setSearch] = useState("");
  const [atribuirSimulado, setAtribuirSimulado] = useState({
    id_simulado: "",
    id_pessoa: "",
  });

  useEffect(() => {
    loadAuth();
    loadAlunos();
    loadSimulados();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadAlunos = () => {
    api
      .get(`/alunos?search=${search}&page=1&limit=10`)
      .then((res) => {
        const newAlunos = res.data.map((aluno) => ({
          key: aluno.id,
          value: aluno.id,
          text: `[${aluno.id}] ${aluno.nome} - ${aluno.email}`,
        }));
        setAlunos(newAlunos);
      })
      .catch((err) => {
        swal("Não foi possivel carregar os simulados!", err, "error");
      });
  };
  const loadSimulados = () => {
    api
      .get("simulado")
      .then(async (res) => {
        let logs = { local: "atribuir_simulado", texto: `listou os simulados` };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        setSimulados(res.data);
      })
      .catch((err) => {
        swal("Não foi possivel carregar os simulados!", err, "error");
      });
  };

  const create = async () => {
    const simuladoValidation = await yup.object().shape({
      id_simulado: yup
        .number("Necessário que informe o simulado")
        .required("Necessário que informe o simulado"),
      id_pessoa: yup
        .number("Necessário que informe o aluno")
        .required("Necessário que informe o aluno"),
    });

    try {
      await simuladoValidation.validate(atribuirSimulado, { abortEarly: true });
      api
        .post(`/admin/atribui/simulado`, atribuirSimulado)
        .then(async (res) => {
          let logs = {
            local: "atribuir_simulado",
            texto: `atribuiu o simulado ${atribuirSimulado.simulado} para a  pessoa ${atribuirSimulado.pessoa}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal("O simulado foi atribuido com sucesso", "", "success");
        })
        .catch((err) => {
          swal("Não foi possível atribuir o simulado", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Atribuir Simulado à Aluno</Title>

          <Form>
            <Form.Group widths="equal">
              <Label>Selecione o aluno</Label>
              <Dropdown
                placeholder="selecione o aluno"
                fluid
                search
                selection
                options={alunos}
                onSearchChange={(e) => {
                  setSearch(e.target.value);
                  loadAlunos();
                }}
                onChange={(e, { value }) =>
                  setAtribuirSimulado({
                    ...atribuirSimulado,
                    id_pessoa: Number(value || 0),
                  })
                }
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Label>Selecione o simulado</Label>
              <select
                onChange={({ target: { value } }) =>
                  setAtribuirSimulado({
                    ...atribuirSimulado,
                    id_simulado: Number(value || 0),
                  })
                }
              >
                {simulados.map((simulado) => (
                  <option value={simulado.id}>{simulado.titulo}</option>
                ))}
              </select>
            </Form.Group>
            <Form.Group>
              <Form.Field control={Button} onClick={() => create()}>
                Atribuir
              </Form.Field>
              <Link to="/">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(AtribuirSimulado);
